import { gql } from '@apollo/client'

const querySubstackFeed = gql`
  query substackFeed($search: String, $order: String, $page: Float!, $limit: Float!) {
    substackFeed(search: $search, order: $order, page: $page, limit: $limit) {
      title
      userName
      description
      link
      total_records
      page
      limit
      posts {
        title
        link
        pubDate
        description
        author
        image
      }
    }
  }
`

const mutationSaveFeedCustomization = gql`
  mutation SaveFeedCustomization(
    $layout: String!
    $userName: String!
    $feedName: String!
    $fields: Fields!
    $selectionLimit: Int!
    $selectedPosts: [SelectedPostInput!]!
    $imagePosition: String
    $columns: Int
    $bgColor: String
    $gradient: String
    $primaryColor: String
    $secondaryColor: String
    $cardBg: String
  ) {
    SaveFeedCustomization(
      layout: $layout
      userName: $userName
      feedName: $feedName
      fields: $fields
      selectionLimit: $selectionLimit
      selectedPosts: $selectedPosts
      imagePosition: $imagePosition
      columns: $columns
      bgColor: $bgColor
      gradient: $gradient
      primaryColor: $primaryColor
      secondaryColor: $secondaryColor
      cardBg: $cardBg
    ) {
      userName
      feedName
      layout
      imagePosition
      columns
      bgColor
      gradient
      primaryColor
      secondaryColor
      cardBg
      selectedPosts {
        title
        link
        pubDate
        author
        image
        description
      }
    }
  }
`

const queryGetAllSubstackFeeds = gql`
  query getAllSubstackFeeds {
    getAllSubstackFeeds {
      _id
      userId
      userName
      feedName
      feedTitle
      feedDescription
      feedLink
      layout
      imagePosition
      selectionLimit
      columns
      bgColor
      gradient
      primaryColor
      secondaryColor
      cardBg
      posts {
        title
        link
        author
        pubDate
        description
        image
      }
      createdAt
      updatedAt
    }
  }
`

const mutationUpdateSubstackFeed = gql`
  mutation updateFeed(
    $feedId: ID!
    $userName: String!
    $feedName: String!
    $layout: String!
    $fields: Fields!
    $selectionLimit: Int!
    $selectedPosts: [SelectedPostInput!]!
    $imagePosition: String
    $columns: Int
    $bgColor: String
    $gradient: String
    $primaryColor: String
    $secondaryColor: String
    $cardBg: String
  ) {
    updateFeed(
      feedId: $feedId
      userName: $userName
      feedName: $feedName
      layout: $layout
      fields: $fields
      selectionLimit: $selectionLimit
      selectedPosts: $selectedPosts
      imagePosition: $imagePosition
      columns: $columns
      bgColor: $bgColor
      gradient: $gradient
      primaryColor: $primaryColor
      secondaryColor: $secondaryColor
      cardBg: $cardBg
    ) {
      layout
      userName
      feedName
      imagePosition
      columns
      bgColor
      gradient
      primaryColor
      secondaryColor
      cardBg
      selectedPosts {
        title
        link
        author
        pubDate
        description
        image
      }
    }
  }
`

const mutationDeleteFeed = gql`
  mutation deleteFeed($feedId: String!) {
    deleteFeed(feedId: $feedId)
  }
`

export {
  querySubstackFeed,
  mutationSaveFeedCustomization,
  mutationDeleteFeed,
  queryGetAllSubstackFeeds,
  mutationUpdateSubstackFeed,
}
